
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24.438 24.438"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_15519","data-name":"Rectangle 15519","width":"24.438","height":"24.438","fill":"#6e60e3"}})])]),_c('g',{attrs:{"id":"Group_45930","data-name":"Group 45930"}},[_c('g',{attrs:{"id":"Group_45926","data-name":"Group 45926","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_33071","data-name":"Path 33071","d":"M7.046 25.23a3.465 3.465 0 01-3.473-3.466V6.462a3.467 3.467 0 015.14-3.035l13.907 7.65a3.464 3.464 0 010 6.072L8.712 24.8a3.441 3.441 0 01-1.666.429M7.039 5.407a1.057 1.057 0 00-1.055 1.055v15.3a1.056 1.056 0 001.565.925l13.909-7.652a1.063 1.063 0 00.418-.417 1.055 1.055 0 00-.417-1.43L7.548 5.537a1.062 1.062 0 00-.51-.13","transform":"translate(-1.776 -1.894)","fill":"#6e60e3"}})])])])
          )
        }
      }
    